import type { CampAvailability } from '../../types/camp'

interface AvailabilityBadgeProps {
  availability: CampAvailability | null | undefined
  locale: 'hu' | 'ro'
}

export default function AvailabilityBadge({ availability, locale }: AvailabilityBadgeProps) {
  if (!availability) return null

  const { available, max } = availability
  const percentage = (available / max) * 100

  let colorClass: string
  let label: string

  if (available === 0) {
    colorClass = 'bg-red-100 text-red-700'
    label = locale === 'hu' ? 'Betelt' : 'Complet'
  } else if (percentage <= 25) {
    colorClass = 'bg-orange-100 text-orange-700'
    label =
      locale === 'hu'
        ? `Még ${available} hely`
        : `Încă ${available} ${available === 1 ? 'loc' : 'locuri'}`
  } else {
    colorClass = 'bg-green-100 text-green-700'
    label =
      locale === 'hu'
        ? `${available} szabad hely`
        : `${available} ${available === 1 ? 'loc disponibil' : 'locuri disponibile'}`
  }

  return (
    <span className={`inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full ${colorClass}`}>
      {label}
    </span>
  )
}
